<template>
    <div class="columns settings is-multiline">
        <div class="column is-12">
            <div class="box">
                <h1 class="title"><i class="fa fa-house"></i> Skolor
                    <router-link :to="{name: 'NewSchool'}" class="button is-warning button-small pull-right">Skapa ny
                        skola
                    </router-link>
                </h1>
            </div>
        </div>
        <div class="column is-12" v-if="models">
            <div class="box">
              <table v-if="schools && Array.isArray(schools)" class="table is-striped is-hoverable">
                <thead>
                  <tr>
                    <th v-for="column in schoolColumns" :key="column.field">
                      {{ column.label }}
                    </th>
                    <th>Actions</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="school in schools" :key="school.id">
                    <td v-for="column in schoolColumns" :key="column.field">
                      {{ school[column.field] }}
                    </td>
                    <td>
                      <button class="button is-small is-info" @click="sendCode(school.id, 'teacher')">
                        <i class="fa fa-envelope"></i>&nbsp;Skicka lärarkod
                      </button>
                      <button class="button is-small is-info" @click="sendCode(school.id, 'class')">
                        <i class="fa fa-envelope"></i>&nbsp;Skicka klasskod
                      </button>
                      <router-link
                        :to="{ name: 'School', params: { id: school.id } }"
                        type="button"
                        class="is-warning button is-small"
                      >
                        <i class="fa fa-eye"></i>
                      </router-link>
                      <button class="button is-small is-danger" @click="deleteSchool(school.id)">
                        <i class="fa fa-trash-o"></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
        </div>
    </div>
</template>

<script>
import modelMixin from '../mixins/model'

export default {
  name: 'Schools',
  mixins: [modelMixin],
  data () {
    return {
      schools: null,
      schoolColumns: null
    }
  },
  watch: {
    models: {
      handler: function (newVal, oldVal) {
        if (newVal.name === 'Schools') {
          this.data = newVal
        }
      },
      deep: true
    }
  },
  computed: {
    hasCreateNewRoute: function () {
      return this.$router.resolve({ name: this.$route.name + ' new' }).href !== '#/'
    },
    hasSingleRoute: function () {
      return this.$router.resolve({ name: this.singularName, params: { id: '123' } }).href !== '#/'
    }
  },
  methods: {
    log: function (item) {
      console.log(item)
    },
    deleteSchool: function (id) {
      const that = this
      const r = confirm('Vill du verkligen ta bort den här skolan?')
      if (r === true) {
        that.$store.dispatch('removeSchool', { id })
          .then((response) => {
            alert(response.data.message)
            that.$store.dispatch('fetchData', { self: this.$route })
              .then(function (response) {
                console.log(response)
                that.schools = that.models
              })
          })
          .catch((error) => {
            console.log(error)
          })
      }
    },
    sendCode: function (id, type) {
      const that = this
      let r = null
      if (type === 'teacher') {
        r = confirm('Vill du verkligen skicka lärarkoden?')
        if (r === true) {
          that.$store.dispatch('sendTeacherCode', { id })
            .then(function (response) {
              alert('Koden skickad!')
            })
            .catch(function (response) {
              alert(response.error.message)
            })
        }
      } else {
        r = confirm('Vill du verkligen skicka klasskoden?')
        if (r === true) {
          that.$store.dispatch('sendClassCode', { id })
            .then((response) => {
              alert('Koden skickad!')
            })
            .catch(function (response) {
              alert(response.error.message)
            })
        }
      }
    }
  },
  mounted () {
    this.schools = this.models
    this.schoolColumns = this.columns
  }
}
</script>
